"use client"

const getCookies = async () => {
     // UNCOMMENT IF BELOW IF BREAKS
     if (typeof document === 'undefined') { 
          // Return an empty object or a default value if this is executed on the server
          return { user: null, token: null };
        }
      
     const cookieString = document.cookie;


     const cookiePairs = cookieString.split(';').map((pair) => pair.trim());

     const cookieObject = {};
     cookiePairs.forEach((pair) => {
     const [key, value] = pair.split('=');
     cookieObject[key] = value;
     })

     // console.log('cpairs', cookiePairs)
     
     const user = cookieObject.user && JSON.parse(cookieObject.user);
     const organization = cookieObject.organization && JSON.parse(cookieObject.organization);
     const token = cookieObject.token && cookieObject.token; 

     return {user: user, organization: organization, token: token}
}

const cookieClear = (name) => {
     document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
   };


const deleteTalnetBrowserCookies = () => {
       cookieClear('token');
       cookieClear('user');
       cookieClear('organization')
     cookieClear('verification')
     window.location.reload()
}

//    export default cookieClear

// Now, cookieObject.token and cookieObject.user contain the values


export { getCookies, cookieClear, deleteTalnetBrowserCookies }